module.exports = __webpack_public_path__ + "static/media/edoc.large.c233c43e.png";